import { validateTokenRequest } from '../api/tokenApi';
import type { TokenValidationResult, TokenErrorCode } from '../types/api.types';

/**
 * Validates a JWT token via the backend API.
 * Orchestrates: call → catch → map to typed result.
 */
export async function validateToken(token: string): Promise<TokenValidationResult> {
  try {
    const data = await validateTokenRequest(token);
    return { success: true, data };
  } catch (err: unknown) {
    const message = err instanceof Error ? err.message : 'UNKNOWN_ERROR';
    const errorCode = message as TokenErrorCode;
    return { success: false, errorCode };
  }
}
